import React, { type PropsWithChildren } from 'react';
import withContext from '../../../lib/withContext';
import { HeaderContextProvider } from '../HeaderContext';
import { LogoMakerProvider, type LogoMakerProviderProps } from './LogoMakerContext';

/**
 * Combines both contexts needed by LogoMaker composites:
 * 1. General header context (withContext → HeaderContextProvider bridge)
 * 2. LogoMaker-specific context (LogoMakerProvider)
 *
 * Usage:
 *   <LogoMakerProviders user={...} rollouts={...} isTransparent>
 *     <LoggedOutLogoMaker showSeoLinks />
 *   </LogoMakerProviders>
 */
const LogoMakerProvidersInner = ({
    children,
    showBackButton,
    integration,
    isTransparent,
    isSticky,
}: PropsWithChildren<LogoMakerProviderProps>) => (
    <HeaderContextProvider>
        <LogoMakerProvider
            showBackButton={showBackButton}
            integration={integration}
            isTransparent={isTransparent}
            isSticky={isSticky}
        >
            {children}
        </LogoMakerProvider>
    </HeaderContextProvider>
);

const LogoMakerProviders = withContext(LogoMakerProvidersInner);

export default LogoMakerProviders;
